import React from 'react';
import { Button } from '@fluentui/react-components';
import { IOrderDetails } from '../../Api/Models/Order';
import CurrencyFormat from '../Helpers/CurrencyFormat';
import { useLocalization } from '../Helpers/useLocalization';

interface IOrderListTableProps {
    orders: IOrderDetails[];
    onDetailsSelected?: (order: IOrderDetails) => void;
}

const OrderListTable: React.FC<IOrderListTableProps> = (props) => {
    const L = useLocalization();
    const isMobile = window.innerWidth < 700;
    if (isMobile) return (
        <div>
            <h2>{L('localization_order_list_heading')}</h2>
            {props.orders.map((order) => (
                <div key={order.orderNumber} style={{borderTop: '1px solid #ddd', marginTop: '1em'}}>
                    <h3>{L('localization_order_number_prefix')}{order.orderNumber}</h3>
                    <p>{L('localization_order_date_label')} {new Date(order.createDate).toLocaleString()}</p>
                    <p>{L('localization_order_total_label')} <CurrencyFormat value={order.total} /></p>
                    <p>{L('localization_order_status_label')} {order.status}</p>
                    {props.onDetailsSelected && <Button onClick={() => props.onDetailsSelected && props.onDetailsSelected(order)}>{L('localization_order_details_button')}</Button>}
                </div>
            ))}
        </div>
    )
    return (
        <div>
            <h2>{L('localization_order_list_heading')}</h2>
            <table className='orders-table'>
                <thead>
                    <tr>
                        <th>{L('localization_order_col_number')}</th>
                        <th style={{width: '100px'}}>{L('localization_order_col_date')}</th>
                        <th style={{width: '150px'}}>{L('localization_order_col_total_amount')}</th>
                        <th style={{width: '150px'}}>{L('localization_order_col_status')}</th>
                        {props.onDetailsSelected && <th style={{width: '100px'}} />}
                    </tr>
                </thead>
                <tbody>
                    {props.orders.map((order) => (
                        <tr key={order.orderNumber}>
                            <td>{order.orderNumber}</td>
                            <td style={{textAlign: 'center'}}>{new Date(order.createDate).toLocaleString()}</td>
                            <td style={{textAlign: 'right'}}><CurrencyFormat value={order.total} /></td>
                            <td style={{textAlign: 'center'}}>{order.status}</td>
                            {props.onDetailsSelected && <td>
                                <Button onClick={() => props.onDetailsSelected && props.onDetailsSelected(order)}>{L('localization_order_details_button')}</Button>
                            </td>}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    )
}

export default OrderListTable;